import { useCallback } from 'react';

import * as evmChains from 'viem/chains';

import { Currency, CAIP_122_IDS, SOLANA_CHAIN_ID } from '@/constants';

const CHAIN_ID_TO_ICON: Record<string, string> = {
  // EVM
  [evmChains.mainnet.id]: '/chains/ethereum.svg',
  [evmChains.bsc.id]: '/chains/bsc.svg',
  [evmChains.polygon.id]: '/chains/pol.svg',
  [evmChains.arbitrum.id]: '/chains/arb.svg',
  [evmChains.base.id]: '/chains/base.svg',
  [evmChains.tron.id]: '/chains/tron.svg',

  // Bitcoin-like
  [BigInt('0x' + CAIP_122_IDS[Currency.BTC].split(':')[1]).toString()]: '/chains/bitcoin.svg',
  [BigInt('0x' + CAIP_122_IDS[Currency.DOGE].split(':')[1]).toString()]: '/chains/doge.svg',
  [BigInt('0x' + CAIP_122_IDS[Currency.LTC].split(':')[1]).toString()]: '/chains/litecoin.svg',

  // Solana
  [SOLANA_CHAIN_ID]: '/chains/solana.svg',
};

type ChainIdLike = string | number | bigint;

export const useChainIdToIcon = () => {
  return useCallback((chainId: ChainIdLike): string | undefined => {
    return CHAIN_ID_TO_ICON[String(chainId)];
  }, []);
};
